export default "__VITE_PUBLIC_ASSET__f2ff74b9__"